import React from "react";
import { Moon, Sun } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useTheme } from "./ThemeContext";
const labels = {
  en: { label: "Night mode", light: "Light", dark: "Night", action: "Toggle night mode" },
  pt: { label: "Modo noturno", light: "Claro", dark: "Noturno", action: "Alternar modo noturno" },
  es: { label: "Modo nocturno", light: "Claro", dark: "Nocturno", action: "Cambiar modo nocturno" },
};
export default function ThemeToggle({ compact = false, testId = "theme-toggle" }) {
  const { lang } = useLang();
  const { theme, toggleTheme } = useTheme();
  const t = labels[lang] || labels.en;
  const Icon = theme === "dark" ? Moon : Sun;
  return <button type="button" className={`xa-theme-toggle ${compact ? "xa-theme-compact" : ""}`} data-testid={testId} onClick={toggleTheme} aria-label={t.label} aria-pressed={theme === "dark"} title={t.action}>
    <Icon size={18} aria-hidden="true" /><span>{theme === "dark" ? t.dark : t.light}</span>
  </button>;
}
